import React, { FunctionComponent } from "react";
import { format, parseISO } from "date-fns";
import {useDispatch, useSelector} from "react-redux";

import {TableRequirement} from "../../../../domains/RequirementList/TableRequirement";

import {stableSort, getComparator } from "../../../../components/BasicTable/tableUtils";
import {
  requirementsSelector,
  isLoadingSelector
} from "../../../../store/ducks/requirementList/selectors";

import * as RequirementListUseCase from "../../../../usecases/requirement/requirementListUseCase";

import { COLUMNS, DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "./constants";

import { getStatusStyle, LoaderWrapper, StyledLink, TableWrapper } from "./style";
import Loader from "../../../../components/Loader";
import { SxProps, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import SortableTableHeader from "../../../../components/BasicTable/SortableTableHead";
import { CATEGORIES } from "../../../../utils";
import CountryWithFlag from "../../../../components/FlagWrapper";

type RequirementListRowProps = {
  requirement: {
    id: string | number;
    alias: string | number;
    country: string | number;
    port: string | number;
    vessel: string | number;
    deal: string | number;
    system: string | number;
    category: string | number;
    user: string | number;
    deadline: string | number;
    status: string | number;
  }
  rowStyles: SxProps
}
export const RequirementListRow: FunctionComponent<RequirementListRowProps> = ({requirement, rowStyles}) => {
  const {alias, category, country, deadline, deal, id, port, system, vessel, user } = requirement;
  const countryWithFlag = <CountryWithFlag country={country as string}>{country}</CountryWithFlag>;
  const categoryFromCategories = CATEGORIES.get(category.toString());
  const formatedDate = format(parseISO(deadline as unknown as string), "P");
  const columnsArray = [alias, countryWithFlag, port, vessel, deal, system, categoryFromCategories, user, formatedDate];
  const requirementLink = `opportunity/${id}`;
  return (
    <TableRow sx={rowStyles}>
      {columnsArray.map((column, index) => {
        return (
          <TableCell
            align={index === 8 ? "center" : "left"}
            key={`${index}`}
          >
            <StyledLink state={requirement} to={requirementLink}>
              {column}
            </StyledLink>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default function RequirementListTable() {
  const dispatch = useDispatch();
 
  const requirements = useSelector(requirementsSelector);
  const isLoading = useSelector(isLoadingSelector);

  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = React.useState<keyof TableRequirement>();


  React.useEffect(() => {
    RequirementListUseCase.fetchRequirements(
      "",
      DEFAULT_PAGE_INDEX,
      DEFAULT_PAGE_SIZE
    )(dispatch);
  }, [dispatch]);

  const onRequestSort = (
    property: keyof TableRequirement,
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  if (isLoading) {
    return (
      <TableWrapper>
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      </TableWrapper>
    );
  }

  return (
    <TableWrapper>
      <TableContainer>
        <Table>
          <SortableTableHeader
            headCells={COLUMNS}
            onRequestSort={onRequestSort}
            order={order}
            orderBy={orderBy as string}
          />
          <TableBody>
            {stableSort(requirements, getComparator(order, orderBy)).map(
              (requirement) => (
                <RequirementListRow
                  requirement={requirement}
                  key={requirement.id}
                  rowStyles={getStatusStyle(requirement?.status.toString())}
                />
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </TableWrapper>
  );
}
